<template>
  <div class="content">
    <base-block class="mb-0" rounded title="User Test Reports">
      <!-- <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Mock Test" active
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >
                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center">Test</b-th>
                    <b-th class="text-center">Correct Answer</b-th>
                    <b-th class="text-center">Incorrect Answer</b-th>
                    <b-th class="text-center">Unattempted Answer</b-th>
                    <b-th class="text-center">Total Score</b-th>
                    <b-th class="text-center">Action</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="report in testReports" :key="report.id">
                    <b-td class="text-center">{{ report.id }}</b-td>
                    <b-td class="text-center">Mock Test {{ report.id }}</b-td>
                    <b-td class="text-center">{{ report.correct }}</b-td>
                    <b-td class="text-center">{{ report.inCorrect }}</b-td>
                    <b-td class="text-center">{{ report.unAttempted }}</b-td>
                    <b-td class="text-center">{{ report.score }}</b-td>
                    <b-td class="text-center">
                      <b-button
                        size="sm"
                        variant="alt-primary"
                        href="/#/backend/tables/user-test-questions-and-answers"
                      >
                        <i class="fa fa-eye"></i>
                      </b-button>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple></p
          ></b-tab>
          <b-tab title="Practice Test" active
            ><p>
              <b-table-simple
                responsive
                bordered
                striped
                table-class="table-vcenter"
              >
                <b-thead>
                  <b-tr>
                    <b-th class="text-center" style="width: 50px">S.NO</b-th>
                    <b-th class="text-center">Parent Topic</b-th>
                    <b-th class="text-center">Sub Topic</b-th>
                    <b-th class="text-center">Correct Answer</b-th>
                    <b-th class="text-center">Incorrect Answer</b-th>
                    <b-th class="text-center">Unattempted Answer</b-th>
                    <b-th class="text-center">Total Score</b-th>
                    <b-th class="text-center">Action</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="report in testReports" :key="report.id">
                    <b-td class="text-center">{{ report.id }}</b-td>
                    <b-td class="text-center">{{ report.test }}</b-td>
                    <b-td class="text-center">{{ report.topic }}</b-td>
                    <b-td class="text-center">{{ report.correct }}</b-td>
                    <b-td class="text-center">{{ report.inCorrect }}</b-td>
                    <b-td class="text-center">{{ report.unAttempted }}</b-td>
                    <b-td class="text-center">{{ report.score }}</b-td>
                     <b-td class="text-center">
                      <b-button
                        size="sm"
                        variant="alt-primary"
                        href="/#/backend/tables/user-test-questions-and-answers"
                      >
                        <i class="fa fa-eye"></i>
                      </b-button>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </p></b-tab
          >
        </b-tabs>
      </div>-->
      <div class="d-flex justify-content-end mb-2">
        <input
          class="form-control"
          type="text"
          placeholder="Search..."
          aria-label="Search"
          style="width: 300px"
        />
      </div>
      <b-table-simple responsive bordered striped table-class="table-vcenter">
        <b-thead>
          <b-tr>
            <b-th class="text-center" style="width: 50px">S.NO</b-th>
            <b-th class="text-center">Parent Topic</b-th>
            <b-th class="text-center">Correct</b-th>
            <b-th class="text-center">Incorrect</b-th>
            <b-th class="text-center">Unattempted</b-th>
            <b-th class="text-center">Percentage</b-th>
            <b-th class="text-center">Total Score</b-th>
            <b-th class="text-center">Questions</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(report, index) in reports" :key="index">
            <b-td class="text-center">{{ index + 1 }}</b-td>
            <b-td class="text-center">{{ report.topic_name }}</b-td>
            <b-td class="text-center">{{ report.total_correct_answer }}</b-td>
            <b-td class="text-center">{{ report.total_incorrect_answer }}</b-td>
            <b-td class="text-center">{{ report.total_unattempted }}</b-td>
            <b-td class="text-center">{{ report.pass_percentage }}</b-td>
            <b-td class="text-center">{{ report.score }}</b-td>
            <b-td class="text-center">
              <b-btn-group>
                <router-link
                  :to="{ name: 'User Test Answers', params: { id: report.id } }"
                >
                  <b-button size="sm" variant="alt-primary">
                    <i class="fa fa-fw fa-eye"></i>
                  </b-button>
                </router-link>
              </b-btn-group>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </base-block>
  </div>
</template>
<script>
import axios from "axios";
export default {
  mounted() {
    this.getReport();
  },
  methods: {
    async getReport() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/tests-report/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.reports = response.data.report_lists;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
  data() {
    return {
      reports: [],
    };
  },
};
</script>